"use client";

import Link from "next/link";
import { useState } from "react";
import { MenuIcon } from "lucide-react";

import { Monogram } from "@/components/brand/monogram";
import { Wordmark } from "@/components/brand/wordmark";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";

// Public-site nav slim. About / Team / Contact routes remain reachable
// by direct URL but are not surfaced in the nav. "Investor Login" is
// the only entry CTA on the public site.
const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "Investor Login", href: "/login" },
];

export function PublicNav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="bg-paper border-b border-drift/30">
      <div className="mx-auto flex w-full max-w-[1280px] items-center justify-between px-6 py-5 md:px-14 md:py-6">
        <Link href="/" aria-label="Sand Point Road — home" className="text-eucalypt">
          <Monogram size="md" />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.label}
              href={link.href}
              className="font-mono text-xs uppercase tracking-[0.22em] text-eucalypt hover:text-sage transition-colors"
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="md:hidden">
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger
              render={
                <Button variant="ghost" size="icon" aria-label="Open menu">
                  <MenuIcon />
                </Button>
              }
            />
            <SheetContent side="right" className="bg-paper">
              <SheetHeader>
                <SheetTitle className="font-serif text-eucalypt">
                  <Wordmark size="sm" />
                </SheetTitle>
              </SheetHeader>
              <nav className="flex flex-col gap-6 px-6 pb-6">
                {NAV_LINKS.map((link) => (
                  <Link
                    key={link.label}
                    href={link.href}
                    onClick={() => setOpen(false)}
                    className="font-mono text-xs uppercase tracking-[0.22em] text-eucalypt hover:text-sage transition-colors"
                  >
                    {link.label}
                  </Link>
                ))}
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
